const echoSeriesBooks = [
  {
    id: '1',
    title: 'The Silent Echo',
    position: 1,
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  },
  {
    id: '2',
    title: 'The Broken Echo',
    position: 2,
    coming_soon: true,
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  },
  {
    id: '3',
    title: 'The Final Echo',
    position: 3,
    coming_soon: true,
    coverImage:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  },
]
export const booksDatabase: Record<string, any> = {
  '1': {
    id: '1',
    title: 'The Silent Echo',
    author: 'Elena Richards',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.7,
    reviewCount: 124,
    description: `In "The Silent Echo," Elena Richards weaves a haunting tale of mystery and suspense. When investigative journalist Mira Hayes returns to her hometown after fifteen years, she's confronted with the unsolved disappearance that drove her away. As Mira digs deeper into the case, she discovers that the town harbors dark secrets—and someone is determined to keep them buried.
With each revelation, Mira finds herself drawn into a web of deception that threatens not only her investigation but her life. As echoes from the past grow louder, she must confront her own demons and the truth about what really happened that fateful night.
A gripping psychological thriller that explores the power of secrets and the weight of silence, "The Silent Echo" will keep readers on the edge of their seats until its shocking conclusion.`,
    publishDate: 'June 15, 2023',
    publisher: 'Midnight Press',
    pages: 342,
    language: 'English',
    isbn: '978-1234567890',
    pov: 'dual-pov',
    tense: 'past-tense',
    crossoverSeries: [
      {
        seriesName: 'Shadow Files',
        seriesSlug: 'shadow-files',
        readingOrder: 2,
      },
    ],
    formats: [
      {
        type: 'Hardcover',
        price: 24.99,
        available: true,
      },
      {
        type: 'Paperback',
        price: 16.99,
        available: true,
      },
      {
        type: 'eBook',
        price: 9.99,
        available: true,
      },
      {
        type: 'Audiobook',
        price: 19.99,
        available: true,
        narrator: 'Sarah Johnson',
      },
    ],
    genres: ['Mystery', 'Thriller', 'Suspense'],
    spiceLevel: 2,
    darknessLevel: 3,
    tropes: ['Small Town Secrets', 'Amateur Detective', 'Cold Case'],
    contentWarnings: ['Violence', 'Strong Language', 'References to Suicide'],
    ageRating: '16+',
    series: {
      name: 'Echo Series',
      position: 1,
      books: echoSeriesBooks,
    },
    characterRelationships: [
      {
        type: 'Enemies to Lovers',
        style: ['Male & Female (MF)', 'Slow Burn'],
        characters: 'Mira Hayes & Detective Ryan Cole',
      },
      {
        type: 'Found Family',
        style: ['Group Dynamic', 'Platonic'],
        characters: 'Mira Hayes, Sarah Chen, & Marcus Thompson',
      },
    ],
    playlist: {
      title: 'The Silent Echo - Official Playlist',
      platform: 'Spotify',
      url: '#',
    },
    events: [
      {
        name: 'Book Signing Tour',
        date: 'October 15, 2023',
        location: 'Bright Pages Bookstore, Seattle',
      },
    ],
    externalLinks: [
      {
        site: 'Amazon',
        url: '#',
      },
      {
        site: 'Apple Books',
        url: '#',
      },
      {
        site: 'Kobo',
        url: '#',
      },
    ],
  },
  '2': {
    id: '2',
    title: 'The Broken Echo',
    author: 'Elena Richards',
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 0,
    reviewCount: 0,
    description: `The highly anticipated sequel to "The Silent Echo". 

Mira Hayes thought the truth would set her free, but in "The Broken Echo," she learns that some secrets are better left buried. As the fallout from her investigation ripples through the town, new threats emerge from the shadows. 

With her life in danger and her allies dwindling, Mira must race against time to uncover a conspiracy that goes deeper than she ever imagined. But this time, the cost of the truth might be more than she can bear.

Pre-order now to be the first to read the explosive next chapter in the Echo Series.`,
    publishDate: 'March 15, 2026',
    publisher: 'Midnight Press',
    pages: 368,
    language: 'English',
    isbn: '978-1234567891',
    coming_soon: true,
    pov: 'dual-pov',
    tense: 'past-tense',
    crossoverSeries: [
      {
        seriesName: 'Shadow Files',
        seriesSlug: 'shadow-files',
        readingOrder: 4,
      },
    ],
    formats: [
      {
        type: 'Hardcover',
        price: 24.99,
        available: true,
      },
      {
        type: 'Paperback',
        price: 16.99,
        available: true,
      },
      {
        type: 'eBook',
        price: 9.99,
        available: true,
      },
      {
        type: 'Audiobook',
        price: 19.99,
        available: false,
        narrator: 'Sarah Johnson (TBA)',
      },
    ],
    genres: ['Mystery', 'Thriller', 'Suspense'],
    spiceLevel: 3,
    darknessLevel: 4,
    tropes: ['Stalking', 'Conspiracy', 'Unreliable Narrator'],
    contentWarnings: ['Violence', 'Psychological Trauma'],
    ageRating: '16+',
    series: {
      name: 'Echo Series',
      position: 2,
      books: echoSeriesBooks,
    },
    characterRelationships: [
      {
        type: 'Established Relationship',
        style: ['Male & Female (MF)', 'Angst'],
        characters: 'Mira Hayes & Detective Ryan Cole',
      },
    ],
    externalLinks: [
      {
        site: 'Amazon',
        url: '#',
      },
    ],
  },
  '3': {
    id: '3',
    title: 'The Final Echo',
    author: 'Elena Richards',
    coverImage:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 0,
    reviewCount: 0,
    description: `The stunning conclusion to the Echo Series. 

Everything has led to this moment. Mira Hayes faces her final confrontation with the forces that have haunted her town for generations. 

More details coming soon.`,
    publishDate: 'September 2026',
    publisher: 'Midnight Press',
    pages: 0,
    language: 'English',
    isbn: 'TBA',
    coming_soon: true,
    pov: 'first-person',
    tense: 'past-tense',
    formats: [
      {
        type: 'Hardcover',
        price: 24.99,
        available: true,
      },
      {
        type: 'eBook',
        price: 9.99,
        available: true,
      },
    ],
    genres: ['Mystery', 'Thriller'],
    spiceLevel: 0,
    darknessLevel: 0,
    tropes: ['Final Girl', 'Good vs Evil'],
    contentWarnings: ['TBA'],
    ageRating: '16+',
    series: {
      name: 'Echo Series',
      position: 3,
      books: echoSeriesBooks,
    },
    characterRelationships: [],
    externalLinks: [],
  },
  // Anthology example — accessible via /book/anthology-1
  'anthology-1': {
    id: 'anthology-1',
    title: 'Shadows & Seduction: A Dark Romance Anthology',
    author: 'Various Authors',
    coverImage:
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.6,
    reviewCount: 156,
    description: `Five of the most compelling voices in dark romance come together for one unforgettable collection. From debt collectors to midnight bargains, each story explores the dangerous intersection of desire and darkness.

All proceeds from this anthology are donated to the Children's Literacy Foundation.

Featuring original stories by Elena Richards, Jessica Martinez, Rachel Kim, Amara Knight, and Emily Watson.`,
    publishDate: 'October 15, 2023',
    publisher: 'Midnight Press',
    pages: 224,
    language: 'English',
    isbn: '978-1234567899',
    isAnthology: true,
    contributors: [
      {
        authorName: 'Elena Richards',
        authorSlug: 'elena-richards',
        storyTitle: 'The Debt Collector',
        pages: 45,
      },
      {
        authorName: 'Jessica Martinez',
        authorSlug: 'jessica-martinez',
        storyTitle: 'Stolen Vows',
        pages: 52,
      },
      {
        authorName: 'Rachel Kim',
        authorSlug: 'rachel-kim',
        storyTitle: 'Midnight Bargain',
        pages: 38,
      },
      {
        authorName: 'Amara Knight',
        authorSlug: 'amara-knight',
        storyTitle: 'Gravity of Sin',
        pages: 41,
      },
      {
        authorName: 'Emily Watson',
        authorSlug: 'emily-watson',
        storyTitle: 'The Arrangement',
        pages: 48,
      },
    ],
    formats: [
      {
        type: 'Paperback',
        price: 18.99,
        available: true,
      },
      {
        type: 'eBook',
        price: 7.99,
        available: true,
      },
    ],
    genres: ['Romance', 'Thriller'],
    spiceLevel: 4,
    darknessLevel: 4,
    tropes: [
      'Dark Romance',
      'Enemies to Lovers',
      'Forced Proximity',
      'Revenge Romance',
    ],
    contentWarnings: ['Violence', 'Sexual Content', 'Kidnapping'],
    ageRating: '18+',
    characterRelationships: [],
    externalLinks: [
      {
        site: 'Amazon',
        url: '#',
      },
      {
        site: 'Apple Books',
        url: '#',
      },
    ],
  },
}
export const relatedMerchandise = [
  {
    id: '1',
    title: 'Silent Echo T-Shirt',
    vendor: 'Literary Apparel Co.',
    image:
      'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 24.99,
    relatedBook: 'The Silent Echo',
    isOfficialMerch: true,
  },
  {
    id: '2',
    title: 'Echo Series Bookmark Set',
    vendor: 'Page Markers',
    image:
      'https://images.unsplash.com/photo-1544947987-f6c4fa25fa4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 12.99,
    relatedBook: 'The Silent Echo',
  },
  {
    id: '3',
    title: 'Silent Echo Art Print',
    vendor: 'BookArt Studio',
    image:
      'https://images.unsplash.com/photo-1582574501058-6f3b5c0c5e6b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 29.99,
    relatedBook: 'The Silent Echo',
    isOfficialMerch: true,
  },
]
export const recommendedBooks = [
  {
    id: 'rec-1',
    title: 'Madison Kate',
    author: 'Tate James',
    coverImage:
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    rating: 4.6,
    reviewCount: 89,
    genres: ['Romance'],
    spiceLevel: 4,
    darknessLevel: 3,
    formats: ['ebook', 'paperback', 'audiobook'],
  },
  {
    id: 'rec-2',
    title: 'Sinners Anonymous',
    author: 'Alisha Williams',
    coverImage:
      'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    rating: 4.5,
    reviewCount: 67,
    genres: ['Romance'],
    spiceLevel: 5,
    darknessLevel: 4,
    formats: ['ebook', 'paperback'],
  },
  {
    id: 'rec-3',
    title: 'Shadow Fae',
    author: 'Jaymin Eve',
    coverImage:
      'https://images.unsplash.com/photo-1516414447565-b14be0adf13e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    rating: 4.8,
    reviewCount: 156,
    genres: ['Fantasy'],
    spiceLevel: 3,
    darknessLevel: 2,
    formats: ['ebook', 'paperback', 'hardcover', 'audiobook'],
  },
  {
    id: 'rec-4',
    title: 'The Debt',
    author: 'C.M. Stunich',
    coverImage:
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    rating: 4.4,
    reviewCount: 43,
    genres: ['Romance'],
    spiceLevel: 4,
    darknessLevel: 3,
    formats: ['ebook', 'paperback', 'audiobook'],
  },
]
